import React from 'react';
import PropTypes from 'prop-types';

import Input from '~c/ui/Input';
import * as validators from '~h/validators';
import formatPhone from '~h/format-phone';

const defaultUser = {
  id: '',

  firstname: '',
  isFirstnameValid: true,

  lastname: '',
  isLastnameValid: true,

  patronymic: '',

  phone: '',
  isPhoneValid: true,

  email: '',
  isEmailValid: true,

  organization: '',
  isOrganizationValid: true,

  position: '',
  isPositionValid: true,

  expertise: '',
  isExpertiseValid: true,

  passportSeries: '',
  isPassportSeriesValid: true,

  passportNumber: '',
  isPassportNumberValid: true,

  passport: '',
  isPassportValid: true,

  passportAuthority: '',
  isPassportAuthorityValid: true,

  passportIssueDate: '',
  isPassportIssueDateValid: true,

  address: '',
  isAddressValid: true,

  diplomaRegNumber: '',
  isDiplomaRegNumberValid: true,

  diplomaQualification: '',
  isDiplomaQualificationValid: true,

  diplomaSeries: '',
  isDiplomaSeriesValid: true,

  diplomaNumber: '',
  isDiplomaNumberValid: true,

  subscribe: true,
  isSubscribeValid: true,
};

const defaultShowFields = {
  firstname: true,
  lastname: true,
  patronymic: true,
  phone: true,
  email: true,
  organization: true,
  position: true,
  expertise: true,
  passportSeries: true,
  passportNumber: true,
  birthday: true,
  passport: true,
  passportAuthority: true,
  passportIssueDate: true,
  address: true,
  diplomaRegNumber: true,
  diplomaQualification: true,
  diplomaSeries: true,
  diplomaNumber: true,
  subscribe: true,
  isSubscribeValid: true,
};

const defaultShowBlocks = {
  contact: true, // name, phone, email
  personal: true, // passport etc.
  diploma: true, // diploma info
};

// TODO: use me in registration forms

/**
 * @description draws user info form
 *
 * @props {func} userInfoCb - callback, used for return user object. userInfoCb = (user) => user;
 * @props {object} user object
 * @props {object} user showFields
 * @props {object} user showBlocks
 */
class UserInfo extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      user: defaultUser,
      showFields: this.props.showFields || defaultShowFields,
      showBlocks: this.props.showBlocks || defaultShowBlocks,
      showСheckNews: this.props.showСheckNews,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.user && prevState.user !== nextProps.user) {
      return { user: nextProps.user };
    }

    return {};
  }

  static propTypes = {
    userInfoCb: PropTypes.func,
  };

  static defaultProps = {
    userInfoCb: () => {},
  };

  componentDidMount() {
    const rawUser = window.user;

    const getUserData = user => {
      const userObject = {
        id: user?.CONTACT_ID || '',
        firstname: user?.FIRST_NAME || '',
        lastname: user?.LAST_NAME || '',
        patronymic: user?.MIDDLE_NAME || '',
        phone: formatPhone(user?.TELEPHONE) || '',
        email: user?.EMAIL || '',
        organization: user?.COMPANY_NAME || '',
        position: user?.JOB_TITLE || '',
        expertise: user?.SPHERE_OF_ACTIVITY || '',
        passport: user?.PASSPORT_NUMBER || '',
        passportAuthority: user?.PASSPORT_AUTHORITY || '',
        passportIssueDate: user?.PASSPORT_ISSUE_DATE?.slice(0, 10) || '',
        birthday: user?.BIRTH_DATE?.slice(0, 10) || '',
        address: user?.REGISTRATION_ADDRESS || '',
      };

      return Object.assign({}, defaultUser, userObject);
    };

    const newUser = rawUser ? getUserData(rawUser) : defaultUser;

    if (newUser) {
      this.setState({ user: newUser });
      this.props.userInfoCb(newUser);
    }
  }

  checkVisibleFields = () => {
    // reset *Valid
    // if (!this.state.user) return;

    const { user, showFields } = this.state;

    const newUser = Object.assign({}, user);

    this.resetValidFieldsInObject(newUser);

    // validate all visible fields
    Object.keys(showFields).forEach(field => {
      const keyValid = `is${field[0].toUpperCase()}${field.slice(1)}Valid`;
      switch (field) {
        case 'firstname':
          newUser[keyValid] = validators.checkName(newUser[field]);
          break;
        case 'lastname':
          newUser[keyValid] = validators.checkName(newUser[field]);
          break;
        case 'patronymic':
          // dont check patronymic
          break;
        case 'phone':
          newUser[keyValid] = validators.checkPhone(newUser[field]);
          break;
        case 'email':
          newUser[keyValid] = validators.checkEmail(newUser[field]);
          break;
        case 'passport':
          newUser[keyValid] = validators.checkPassport(newUser[field]);
          break;
        case 'passportIssueDate':
          newUser[keyValid] = validators.checkDate(newUser[field]);
          break;
        case 'birthday':
          newUser[keyValid] = validators.checkDate(newUser[field]);
          break;
        default:
          newUser[keyValid] = validators.checkNotEmpty(newUser[field]);
          break;
      }
    });

    this.setState({ user: newUser });
    // check visible
    return this.checkAllValidKeys(newUser);
  };

  /**
   * @description search all fields wich ends on *Valid and set it to 'true'. Checks only boolean fields.
   *
   * @param {object} obj object to be reseted
   *
   * @returns nothing
   */
  resetValidFieldsInObject = obj => {
    Object.keys(obj).forEach(key => {
      if (key.match(/Valid$/) != null) {
        if (typeof obj[key] === 'boolean') {
          // eslint-disable-next-line
          obj[key] = true;
        }
      }
    });
  };

  /**
   * @description search and checks all fields wich ends on *Valid.
   *
   * @param {object} obj object to be reseted
   *
   * @returns {boolean} true if all fields === true
   */
  checkAllValidKeys = obj => {
    return Object.keys(obj).every(key => {
      if (key.match(/Valid$/) != null && obj[key] === false) {
        return false;
      }
      return true;
    });
  };

  render() {
    const { user, showFields, showBlocks, showСheckNews } = this.state;
    const { disabled } = this.props;

    return (
      <React.Fragment>
        {showBlocks.contact && (
          <React.Fragment>
            {showСheckNews && (
              <p className="title member__profile-title">Персональные данные</p>
            )}
            <div className="inp-wrap">
              {showFields.lastname && (
                <label className="inp" htmlFor={`lastnameInput_${user.id}`}>
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className={
                      user.isLastnameValid ? `inp__field` : `inp__field`
                      // : `inp__field inp__field--error`
                    }
                    type="text"
                    name={`lastnameInput_${user.id}`}
                    id={`lastnameInput_${user.id}`}
                    placeholder=" "
                    value={user.lastname}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.lastname = trimmed;
                      newUser.isLastnameValid = validators.checkName(trimmed);
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.lastname = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Фамилия</p>
                </label>
              )}

              {showFields.firstname && (
                <label className="inp" htmlFor={`firstnameInput_${user.id}`}>
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className={
                      user.isFirstnameValid ? `inp__field` : `inp__field`
                      // : `inp__field inp__field--error`
                    }
                    type="text"
                    name={`firstnameInput_${user.id}`}
                    id={`firstnameInput_${user.id}`}
                    placeholder=" "
                    value={user.firstname}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.firstname = trimmed;
                      newUser.isFirstnameValid = validators.checkName(trimmed);
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.firstname = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Имя</p>
                </label>
              )}

              {showFields.patronymic && (
                <label className="inp" htmlFor={`patronymicInput_${user.id}`}>
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className="inp__field"
                    type="text"
                    name={`patronymicInput_${user.id}`}
                    id={`patronymicInput_${user.id}`}
                    placeholder=" "
                    value={user.patronymic}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.patronymic = trimmed;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.patronymic = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Отчество</p>
                </label>
              )}

              {showFields.phone && (
                <label className="inp">
                  <input
                    autoComplete="off"
                    className="inp__field"
                    disabled={true}
                    type="text"
                    value={'+' + user.phone.replace(/[^0-9]/g, '')}
                    placeholder=""
                  />
                  <p className="inp__label">Моб. телефон</p>
                </label>
              )}

              {showFields.email && (
                <label className="inp" htmlFor={`emailInput_${user.id}`}>
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className={
                      user.isEmailValid
                        ? `inp__field`
                        : `inp__field inp__field--error`
                    }
                    type="email"
                    name={`email`}
                    id={`emailInput_${user.id}`}
                    placeholder=" "
                    value={user.email}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.email = trimmed;
                      newUser.isEmailValid = validators.checkEmail(trimmed);
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.email = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Эл. почта</p>
                </label>
              )}
            </div>
            {showBlocks.personal && <div className="separate"></div>}
          </React.Fragment>
        )}
        {showBlocks.personal && (
          <React.Fragment>
            <div className="inp-wrap">
              {showFields.organization && (
                <label className="inp" htmlFor={`organizationInput_${user.id}`}>
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className="inp__field"
                    type="text"
                    name={`organizationInput_${user.id}`}
                    id={`organizationInput_${user.id}`}
                    placeholder=" "
                    value={user.organization}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.organization = trimmed;
                      newUser.isOrganizationValid = validators.checkNotEmpty(
                        trimmed,
                      );
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.organization = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Название организации</p>
                </label>
              )}

              {showFields.position && (
                <label className="inp" htmlFor={`positionInput_${user.id}`}>
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className="inp__field"
                    type="text"
                    name={`positionInput_${user.id}`}
                    id={`positionInput_${user.id}`}
                    placeholder=" "
                    value={user.position}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.position = trimmed;
                      newUser.isPositionValid = validators.checkNotEmpty(
                        trimmed,
                      );
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.position = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Должность</p>
                </label>
              )}
            </div>
            <div className="inp-wrap">
              {showFields.passport && (
                <Input
                  disabled={disabled}
                  passport
                  value={user.passport}
                  getCode
                  data-valid={true}
                  onBlur={e => {
                    const newUser = Object.assign({}, user);
                    newUser.isPassportValid = validators.checkPassport(
                      e.target.value,
                    );

                    if (!newUser.isPassportValid) newUser.passport = '';
                    this.props.userInfoCb(newUser);
                    this.setState({ user: newUser });
                  }}
                  onChange={value => {
                    const newUser = Object.assign({}, user);
                    newUser.passport = value;
                    this.props.userInfoCb(newUser);
                    this.setState({ user: newUser });
                  }}
                  placeholder=" "
                >
                  <p className="inp__label">Серия и номер паспорта</p>
                </Input>
              )}

              {showFields.passportIssueDate && (
                <Input
                  disabled={disabled}
                  date
                  value={user.passportIssueDate}
                  getCode
                  data-valid={true}
                  onBlur={e => {
                    const newUser = Object.assign({}, user);
                    newUser.isPassportIssueDateValid = validators.checkDate(
                      e.target.value,
                    );
                    if (!newUser.isPassportIssueDateValid)
                      newUser.passportIssueDate = '';
                    this.props.userInfoCb(newUser);
                    this.setState({ user: newUser });
                  }}
                  onChange={value => {
                    const newUser = Object.assign({}, user);
                    newUser.passportIssueDate = value;
                    this.props.userInfoCb(newUser);
                    this.setState({ user: newUser });
                  }}
                  placeholder=" "
                >
                  <p className="inp__label">Дата выдачи</p>
                </Input>
              )}

              {showFields.birthday && (
                <Input
                  disabled={disabled}
                  date
                  value={user.birthday}
                  getCode
                  data-valid={true}
                  onBlur={e => {
                    const newUser = Object.assign({}, user);
                    newUser.isBirthdayValid = validators.checkDate(
                      e.target.value,
                    );
                    if (!newUser.isBirthdayValid) newUser.birthday = '';
                    this.props.userInfoCb(newUser);
                    this.setState({ user: newUser });
                  }}
                  onChange={value => {
                    const newUser = Object.assign({}, user);
                    newUser.birthday = value;
                    this.props.userInfoCb(newUser);
                    this.setState({ user: newUser });
                  }}
                  placeholder=" "
                >
                  <p className="inp__label">Дата рождения</p>
                </Input>
              )}

              {showFields.passportAuthority && (
                <label
                  className="inp inp--lg"
                  htmlFor={`passportAuthorityInput_${user.id}`}
                >
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className="inp__field"
                    type="text"
                    name={`passportAuthorityInput_${user.id}`}
                    id={`passportAuthorityInput_${user.id}`}
                    placeholder=" "
                    value={user.passportAuthority}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.passportAuthority = trimmed;
                      newUser.isPassportAuthorityValid = validators.checkNotEmpty(
                        trimmed,
                      );
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.passportAuthority = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Кем выдан</p>
                </label>
              )}

              {showFields.address && (
                <label
                  className="inp inp--lg"
                  htmlFor={`addressInput_${user.id}`}
                >
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className="inp__field"
                    type="text"
                    name={`addressInput_${user.id}`}
                    id={`addressInput_${user.id}`}
                    placeholder=" "
                    value={user.address}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.address = trimmed;
                      newUser.isAddressValid = validators.checkNotEmpty(
                        trimmed,
                      );
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.address = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Адрес регистрации</p>
                </label>
              )}
            </div>
          </React.Fragment>
        )}
        {(showBlocks.personal || showBlocks.contact) && showBlocks.diploma && (
          <div className="separate"></div>
        )}
        {showBlocks.diploma && (
          <React.Fragment>
            <p className="title member__profile-title">Документ о высшем образовании</p>
            <div className="inp-wrap">
              {showFields.diplomaRegNumber && (
                <label className="inp" htmlFor={`diplomaRegNumber_${user.id}`}>
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className="inp__field"
                    type="text"
                    name={`diplomaRegNumber_${user.id}`}
                    id={`diplomaRegNumber_${user.id}`}
                    placeholder=" "
                    value={user.diplomaRegNumber}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.diplomaRegNumber = trimmed;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.diplomaRegNumber = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Рег. номер диплома и дата выдачи</p>
                </label>
              )}
              {showFields.diplomaQualification && (
                <label
                  className="inp"
                  htmlFor={`diplomaQualification_${user.id}`}
                >
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className="inp__field"
                    type="text"
                    name={`diplomaQualification_${user.id}`}
                    id={`diplomaQualification_${user.id}`}
                    placeholder=" "
                    value={user.diplomaQualification}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.diplomaQualification = trimmed;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.diplomaQualification = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Присвоенная квалификация</p>
                </label>
              )}
            </div>
            <div className="inp-wrap">
              {showFields.diplomaSeries && (
                <label className="inp" htmlFor={`diplomaSeries_${user.id}`}>
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className="inp__field"
                    type="text"
                    name={`diplomaSeries_${user.id}`}
                    id={`diplomaSeries_${user.id}`}
                    placeholder=" "
                    value={user.diplomaSeries}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.diplomaSeries = trimmed;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.diplomaSeries = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Серия диплома</p>
                </label>
              )}
              {showFields.diplomaNumber && (
                <label className="inp" htmlFor={`diplomaNumber_${user.id}`}>
                  <input
                    autoComplete="off"
                    disabled={disabled}
                    className="inp__field"
                    type="text"
                    name={`diplomaNumber_${user.id}`}
                    id={`diplomaNumber_${user.id}`}
                    placeholder=" "
                    value={user.diplomaNumber}
                    onBlur={e => {
                      const trimmed = e.target.value.trim();
                      const newUser = Object.assign({}, user);
                      newUser.diplomaNumber = trimmed;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                    onChange={e => {
                      const newUser = Object.assign({}, user);
                      newUser.diplomaNumber = e.target.value;
                      this.props.userInfoCb(newUser);
                      this.setState({ user: newUser });
                    }}
                  />
                  <p className="inp__label">Номер диплома</p>
                </label>
              )}
            </div>
          </React.Fragment>
        )}
        {showСheckNews && (
          <>
          <div className="separate" />
          <div className="check registration__policy">
            <label
              className="check__label"
              htmlFor={`subscribeCheckbox_${user.id}`}
            >
              <input
                autoComplete="off"
                disabled={disabled}
                className="check__inp"
                type="checkbox"
                name={`subscribeCheckbox_${user.id}`}
                id={`subscribeCheckbox_${user.id}`}
                required=""
                checked={user.subscribe}
                onChange={e => {
                  const newUser = Object.assign({}, user);
                  newUser.subscribe = e.target.checked;
                  this.props.userInfoCb(newUser);
                  this.setState({ user: newUser });
                }}
              />
              <span className="check__box" />
              <p className="check__text">
                Я хочу получать новостные и акционные рассылки Академии
              </p>
            </label>
          </div>
          </>
        )}
      </React.Fragment>
    );
  }
}

export default UserInfo;
